import { IBuyPackageParameters } from '../services';
import { TAppState } from '../types';
import { selectBuyPackageModalData } from './buyPackageModal';

export const selectBuyPackageParameters = (state: TAppState): IBuyPackageParameters => {
  const { packageId, polygonIds, autoProlong, widgetSource } = selectBuyPackageModalData(state);

  return {
    packageId: packageId as number,
    polygonIds: polygonIds!,
    autoProlong,
    widgetSource: widgetSource!,
  };
};
